import type { JSONContent } from '@tiptap/core';

/**
 * Editor content for a rewrite of selected text. The text goes in as text, never parsed as
 * HTML; its lines become paragraphs, matching how the selected blocks were joined when sent.
 */
export function replacementContent(text: string): JSONContent[] {
  const lines = text.split(/\n+/).filter((line) => line.trim());
  if (lines.length === 1) return [{ type: 'text', text: lines[0]! }];
  return lines.map((line) => ({ type: 'paragraph', content: [{ type: 'text', text: line }] }));
}
